export default __webpack_public_path__ + "static/media/2791.ed848f22.png";